module.exports = __webpack_public_path__ + "static/img/certificate_img22.4e388831.jpg";